module.exports = __webpack_public_path__ + "static/media/sort-amount-down-alt.c595a00f.svg";